module.exports = __webpack_public_path__ + "img/trade_end.05d890d1.png";